let isResizing = $(window).outerWidth() > 1024 ? true : false
$('.js_goods__materials-item').eq(0).addClass('active')
activeVariants()
coverPosition()
activeTabs()
activeTabsAdapt()
galleryHeight()
gallerySizes()

$(window).on('resize', function () {
    coverPosition()
    galleryHeight()

    if ($(window).outerWidth() > 1024) {
        $('.js_goods__tabs-content').removeAttr('style')
        $('.js_goods__tabs-title').removeClass('active')
        $('.js_goods__tabs-title').off('click')
        isResizing = true
    } else {
        if (isResizing) {
            activeTabsAdapt()
            isResizing = false
        }
    }
})

$('.js_goods__colors-link').hover(function () {
    $('.js_goods__colors-holder').removeAttr('style').stop()
    $(this).closest('.js_goods__colors-item').find('.js_goods__colors-holder').fadeIn()
}, function () {
    $(this).closest('.js_goods__colors-item').find('.js_goods__colors-holder').fadeOut()
})

$('.js_goods__back').on('click', function () {
    window.history.back();
})

$('.js_goods__materials-item').on('click', function () {
    if (!$(this).hasClass('active')) {
        $('.js_goods__materials-item').removeClass('active')
        $(this).addClass('active')
        activeVariants()
    }
})

function coverPosition() {
    let height = $('.js_goods__cover').innerHeight()
    $('.js_goods__info').css('min-height', height)
    if ($(window).outerWidth() < 1024) {
        $('.js_goods__cover').prependTo('.js_goods__right')
        $('.js_goods__info').removeAttr('style')
    } else {
        $('.js_goods__cover').prependTo('.js_goods__left')
    }
}

function activeTabs() {
    $('.js_goods__tabs-button').eq(0).addClass('active')
    $('.js_goods__tabs-item').eq(0).addClass('active')
    $('.js_goods__tabs-button').on('click', function () {
        if (!$(this).hasClass('active')) {
            let tabName = $(this).data('tab')
            $('.js_goods__tabs-button').removeClass('active')
            $(this).addClass('active')
            $('.js_goods__tabs-item').removeClass('active')
            $(`.js_goods__tabs-item[data-tab="${tabName}"]`).addClass('active')
        }
    })
}

function activeTabsAdapt() {
    if ($(window).outerWidth() < 1024) {
        if (!$('.js_goods__tabs-title').eq(0).hasClass('active')) {
            $('.js_goods__tabs-title').eq(0).addClass('active')
            $('.js_goods__tabs-content').eq(0).slideDown(0)
        }

        $('.js_goods__tabs-title').on('click', function (e) {
            let target = $(e.target).hasClass('js_goods__tabs-title') ? e.target : $(e.target).closest('.js_goods__tabs-title')
            if ($(target).hasClass('active')) {
                $(target).removeClass('active')
                $(target).next('.js_goods__tabs-content').slideUp()
            } else {
                $('.js_goods__tabs-title').removeClass('active')
                $('.js_goods__tabs-content').slideUp(0)
                $(target).addClass('active')
                $(target).next('.js_goods__tabs-content').slideDown()
            }
        })
    }
}

function galleryHeight() {
    if ($(window).outerWidth() < 568) {
        let width = $('.js_goods__gallery-wrapper').outerWidth()
        $('.js_goods__gallery-wrapper').height(width)
    } else {
        $('.js_goods__gallery-wrapper').removeAttr('style')
    }
}

function gallerySizes() {
    let items = $('.js_goods__gallery').find('.js_goods__gallery-item')
    let length = items.length
    if (length == 1) {
        items.eq(0).addClass('horizontal')
    } else if (length == 2 || length == 4) {
        items.addClass('vertical')
    } else if (length == 3) {
        items.eq(0).addClass('vertical')
        items.eq(1).addClass('vertical')
        items.eq(2).addClass('horizontal')
    } else if (length >= 5) {
        if (length % 3 == 2) {
            items.each((i, el) => {
                if ((i + 1) % 3 == 0) {
                    $(el).addClass('horizontal')
                } else {
                    $(el).addClass('square')
                }
            })
        } else {
            items.each((i, el) => {
                if (i % 3 == 0) {
                    $(el).addClass('horizontal')
                } else {
                    $(el).addClass('square')
                }
            })
        }
    }
}

function activeVariants() {
    if ($('.js_goods__colors-item').length && $('.js_goods__materials-item ').length) {
        let activeVariants = $('.js_goods__materials-item.active').data('var')
        if (activeVariants == 'all') {
            $('.js_goods__colors-item').addClass('active')
        } else {
            $('.js_goods__colors-item').removeClass('active')
            activeVariants = activeVariants.split(',')
            activeVariants.forEach((el, i) => {
                $(`.js_goods__colors-item[data-var="${el}"]`).addClass('active')
            })
        }
    }
}